import script from "./Growth.vue?vue&type=script&setup=true&lang=ts"
export * from "./Growth.vue?vue&type=script&setup=true&lang=ts"

import "./Growth.vue?vue&type=style&index=0&id=9c4b269a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c4b269a"]])

export default __exports__